import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { StationaryArea } from '@thive/fddm-types';
import { Stack } from '@mui/system';
import { memo, useCallback, useMemo } from 'react';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useHasOmniVehicles } from '@/modules/vehicles/hooks/useHasOmniVehicles';
import { CrabSettingInput } from '../common/CrabSettingInput';

type Props = {
  selectedStationaryArea: StationaryArea;
};

function StationaryPoiPreferencesComponent({ selectedStationaryArea }: Props) {
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const hasOmniVehicles = useHasOmniVehicles();
  const crabSetting = selectedStationaryArea.stationaryPoiSpecs[0]?.crabSetting ?? 0;

  const handleCrabChange = useCallback(
    (value: number) => {
      fddmSvc.setPreference('stationaryArea.stationaryPoiSpecs.crabSetting', value);
      fddmSvc.updateArea({
        ...selectedStationaryArea,
        stationaryPoiSpecs: [
          {
            ...selectedStationaryArea.stationaryPoiSpecs[0],
            crabSetting: value,
          },
        ],
      });
      const smoothHeadingValue =
        value !== 0 ? true : fddmSvc.getPreference('connection.smoothHeading');
      const relatedConnections = useFloorplanDesignStore
        .getState()
        .interAreaConnectionActions.getRelatedTo([selectedStationaryArea.id]);
      if (relatedConnections.length > 0) {
        fddmSvc.updateInterAreaConnections(
          relatedConnections.map((conn) => ({
            ...conn,
            aToBConnections: conn.aToBConnections.map((c) => ({
              ...c,
              smoothHeading: smoothHeadingValue,
            })),
            bToAConnections: conn.bToAConnections.map((c) => ({
              ...c,
              smoothHeading: smoothHeadingValue,
            })),
          })),
        );
      }
    },
    [fddmSvc, selectedStationaryArea],
  );

  if (!hasOmniVehicles) return null;

  return (
    <Stack spacing={1}>
      <PropertiesLabel i18nkey='interface:properties.area.crab_setting'>
        <CrabSettingInput value={crabSetting} onChange={handleCrabChange} />
      </PropertiesLabel>
    </Stack>
  );
};

export const StationaryPoiPreferences = memo(StationaryPoiPreferencesComponent);